module.exports = __webpack_public_path__ + "static/media/nima_moving_head_body.5e23279a.png";